
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cv-upload-home/submission-complete",
      function () {
        return require("private-next-pages/cv-upload-home/submission-complete/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cv-upload-home/submission-complete"])
      });
    }
  